import React from 'react'
import { Card } from './Card'


export const CardContainer = () => {
  return (
    <div className=' py-10'>
        <Card />
    </div>
  )
}
